namespace Controlli {

    export namespace Tabella {

        let _panelColonne;
        let _panelColonneBarracharmSecondary;

        let _panelFiltro: JQuery<Element>;

        let NomeGriglia: string;

        let ListaRigheSelezionate: Set<number>;

        export let ElencoFiltri: Set<FiltroTabella>;
        export let ElencoColonna: Set<ColonnaTabella>;
        export let ElencoOrdine: Set<OrdineTabella>;

        let IsOpen: boolean;

        export function Inizialize() {
            ListaRigheSelezionate = new Set<number>();
            $("[data-riga-id]").prop("checked", false);

            //---------------------------------------------------------------------------------------

            ChangeToolbarStatus();

            if ((NomeGriglia != $("#utilityTabella").data("nome-griglia")) && NomeGriglia != undefined) {
                _panelFiltro.toggle();
                ElencoFiltri = new Set<FiltroTabella>;
            }

            LoadVisibile();
            LoadFiltri();
            LoadOrdine();

            _panelColonne = $("[data-charm-colonne]");
            _panelColonne.css('transition', 'all 0.5s ease');
            _panelColonneBarracharmSecondary = $("[data-barracharm-secondary]");

            _panelFiltro = $("#rigafiltri");
            _panelFiltro.css('transition', 'all 0.5s ease');

            // Bind Eventi
            //---------------------------------------------------------------------------------------

            $(document).on("Overlay_HideEvent", () => HidePanelColonne());

            $("[data-filtro-apri]").on("click", (e: JQuery.Event) => ShowHideFiltro(e));
            $("[data-filtri-applica]").on("click", (e: JQuery.Event) => OnFilterTable(e));

            $("[data-ordine-nome]").on("click", (e: JQuery.Event) => OnOrderTable(e));

            $("[data-charm-colonne-apri]").on("click", (e: JQuery.Event) => ShowPanelColonne(e));
            $("[data-charm-colonne-chiudi]").on("click", () => HidePanelColonne());
            $("[data-barracharm-close]").on("click", () => HidePanelColonne());
            $("[data-charm-colonne-tutto]").on("change", (e: JQuery.Event) => SelezionaNascondiTutto(e));
            $("[data-colonna-visibile]").on("change", (e: JQuery.Event) => SelezionaNascondiColonna(e));

            //---------------------------------------------------------------------------------------

            $("[data-riga]").on("click", (e: JQuery.Event) => OnRigaClick(e));

            $("[data-tabella-nuovo]").on("click", (e: JQuery.Event) => OnNuovoClick(e));
            $("[data-tabella-modifica]").on("click", (e: JQuery.Event) => OnModificaClick(e));
            $("[data-tabella-elimina]").on("click", (e: JQuery.Event) => OnEliminaClick(e));
            $("[data-tabella-duplica]").on("click", (e: JQuery.Event) => OnDuplicaClick(e));
            $("[data-tabella-compara]").on("click", (e: JQuery.Event) => OnCompareClick(e));

            //---------------------------------------------------------------------------------------

            $("[data-export-pdf]").on("click", (e: JQuery.Event) => OnExportPDF(e));
            $("[data-export-excel]").on("click", (e: JQuery.Event) => OnExportEXCEL(e));
            $("[data-export-word]").on("click", (e: JQuery.Event) => OnExportWORD(e));
            $("[data-export-csv]").on("click", (e: JQuery.Event) => OnExportCSV(e));
            $("[data-export-image]").on("click", (e: JQuery.Event) => OnExportIMAGE(e));
            $("[data-export-json]").on("click", (e: JQuery.Event) => OnExportJSON(e));
            $("[data-export-xml]").on("click", (e: JQuery.Event) => OnExportXML(e));

            //---------------------------------------------------------------------------------------

            $("[data-tabella-pager]").on("click", (e: JQuery.Event) => OnPagerChange(e));
        }

        //----------------------------------------------------------------------------------------------

        export function ShowPanelColonne(e: any) {
            e.preventDefault();
            $(e.currentTarget).tooltip("hide");

            IsOpen = true;
            _panelColonne.css('margin-right', '0');
            _panelColonne.css('width', "500px");

            Overlay.Show(false);
        }
        function HidePanelColonne() {
            if (IsOpen) {
                _panelColonne.css('margin-right', "-500px");
                _panelColonneBarracharmSecondary.css('margin-right', "-1000px");

            }

            IsOpen = false;
            Overlay.Hide(false);
        }

        //----------------------------------------------------------------------------------------------

        function SelezionaNascondiTutto(e: any) {
            let _obj = $(e.currentTarget);

            $("[data-colonna-visibile]").prop("checked", _obj.prop('checked'));

            if (_obj.prop('checked')) {
                $("[data-colonna-nome]").show();

                SetVisibileColonna(true, null);
            } else {
                $("[data-colonna-nome]").hide();
                LoadVisibile(true);
            }
        }
        function SelezionaNascondiColonna(e: any) {
            let _obj = $(e.currentTarget);

            if (_obj.prop('checked')) {
                $("[data-colonna-nome='" + _obj.data("colonna-visibile") + "']").show();

                SetVisibileColonna(true, _obj.data("colonna-visibile"));
            } else {
                $("[data-colonna-nome='" + _obj.data("colonna-visibile") + "']").hide();

                SetVisibileColonna(false, _obj.data("colonna-visibile"));
            }

            if ($("[data-colonna-visibile]:checkbox:checked").length == 0)
                LoadVisibile(true);
        }

        function LoadVisibile(SetDefault?: boolean) {
            if ((NomeGriglia != $("#utilityTabella").data("nome-griglia")) || (SetDefault != null && SetDefault)) {
                NomeGriglia = $("#utilityTabella").data("nome-griglia");

                ElencoColonna = new Set<ColonnaTabella>();

                $("[data-colonna-nome]").each(function () {
                    let _this = $(this);

                    ElencoColonna.add({
                        Nome: _this.data("colonna-nome"),
                        IsVisibile: false
                    });
                });
                $("[data-colonna-visibile-default]").each(function () {
                    let _this = $(this);

                    let _default = _this.data("colonna-visibile-default");

                    if (_default != null && _default == "True") {
                        SetVisibileColonna(_default, _this.data("colonna-visibile"));
                    }
                });
            }

            $("[data-colonna-visibile]").prop('checked', false);
            $("[data-colonna-nome]").hide();

            for (let item of ElencoColonna) {
                $("[data-colonna-visibile='" + item.Nome + "']").prop('checked', item.IsVisibile);
                if (item.IsVisibile)
                    $("[data-colonna-nome='" + item.Nome + "']").show();
                else
                    $("[data-colonna-nome='" + item.Nome + "']").hide();
            }

            let _count: number = 0;
            ElencoColonna.forEach(function (item) {
                if (item.IsVisibile)
                    _count++;
            });
            if (_count == ElencoColonna.size)
                $("[data-charm-colonne-tutto]").prop('checked', true);
        }

        function SetVisibileColonna(Valore: boolean, Nome?: string) {
            for (let item of ElencoColonna) {
                if (Nome == null)
                    item.IsVisibile = Valore;
                else if (Nome == item.Nome)
                        item.IsVisibile = Valore;
            }
        }

        //----------------------------------------------------------------------------------------------

        function ShowHideFiltro(e: any) {
            e.preventDefault();
            $(e.currentTarget).tooltip("dispose");

            _panelFiltro.toggle();

            if (_panelFiltro.is(":hidden")) {
                ElencoFiltri = null;
                CallAjaxFiltriOrdine();
            }
        }
        function LoadFiltri() {
            if (ElencoFiltri != null && ElencoFiltri != undefined && ElencoFiltri.size > 0) {
                for (let item of ElencoFiltri) {

                    let _col = $("[data-filtro-nome='" + item.NomeFiltro + "']");

                    if (_col.find("[data-filtri-valore]") != null) {
                        _col.find("[data-filtri-valore]").val(item.Valore);
                    }
                }
                $("#rigafiltri").show();
            }

        }

        function OnFilterTable(e: any) {
            e.preventDefault();
            ElencoFiltri = new Set<FiltroTabella>();
            $("[data-filtri-valore]").each(function () {
                let _val = $(this).val();

                if (_val != null && _val != undefined && _val != "") {
                    ElencoFiltri.add({
                        NomeFiltro: $(this).closest("[data-filtro-nome]").data("filtro-nome"),
                        NomeEntity: $(this).closest("[data-colonna-nome]").data("colonna-nome"),
                        Valore: _val
                    });
                }

            });

            CallAjaxFiltriOrdine();
        }

        //----------------------------------------------------------------------------------------------

        function LoadOrdine() {
            if (ElencoOrdine != null) {
                for (let item of ElencoOrdine) {
                    let _obj = $("[data-ordine-nome='" + item.Nome + "']");
                    let _classfiltro = _obj.find(".filtro");

                    _obj.show();
                    _classfiltro.show();

                    _classfiltro.find("[data-ordine-numero]").html(item.Ordine.toString());

                    switch (item.Tipo) {
                        case SortOrder.Ascending:
                            _classfiltro.find("[data-ordine-tipo]").addClass("fa-arrow-up");
                            break;
                        case SortOrder.Descending:
                            _classfiltro.find("[data-ordine-tipo]").addClass("fa-arrow-down");
                            break;
                        default:
                    }

                }
            }
        }

        function OnOrderTable(e: any) {
            if ((NomeGriglia != $("#utilityTabella").data("nome-griglia"))) {
                ElencoOrdine = new Set<OrdineTabella>()
            }

            e.preventDefault();

            let _tmpSortOrder: SortOrder;
            let _tmpNumeroOrdine: number;

            let _classfiltro = $(e.currentTarget).find(".filtro");
            if (_classfiltro.is(":hidden")) {
                _tmpSortOrder = SortOrder.Ascending;
                _tmpNumeroOrdine = 1;
            } else {
                if ($(e.currentTarget).find("[data-ordine-tipo]").hasClass("fa-arrow-up")) {
                    _tmpSortOrder = SortOrder.Descending;
                } else if ($(e.currentTarget).find("[data-ordine-tipo]").hasClass("fa-arrow-down")) {

                    //bisogna togliere l'ordine
                    _tmpSortOrder = SortOrder.None;
                }

                _tmpNumeroOrdine = Number.parseInt(_classfiltro.find("[data-ordine-numero]").html());
            }



            let _tmpOrdine: OrdineTabella = {
                Nome: $(e.currentTarget).data("ordine-nome"),
                Ordine: _tmpNumeroOrdine,
                Tipo: _tmpSortOrder
            };

            if (ElencoOrdine == null)
                ElencoOrdine = new Set<OrdineTabella>();

            for (let item of ElencoOrdine) {
                if (item.Nome == _tmpOrdine.Nome)
                    ElencoOrdine.delete(item);
            }

            let _contatore: number = 1;
            for (let item of ElencoOrdine) {
                item.Ordine = _contatore;
                _contatore++;
            }

            _tmpOrdine.Ordine = _contatore;
            _classfiltro.find("[data-ordine-numero]").html(_contatore.toString());

            if (_tmpOrdine.Tipo != SortOrder.None)
                ElencoOrdine.add(_tmpOrdine);


            CallAjaxFiltriOrdine();
        }

        //----------------------------------------------------------------------------------------------

        function CallAjaxFiltriOrdine(_url?: string): void {
            let ajaxSettings: JQueryAjaxSettings = {
                url: (_url ?? $("[data-filtro-url]").data("filtro-url")),
                contentType: "application/json; charset=utf-8",
                dataType: "html",
                //data: (ElencoFiltri != null ? JSON.stringify({ filtri: Array.from(ElencoFiltri), ordine: Array.from(ElencoOrdine) }) : null),
                data: JSON.stringify({ filtri: (ElencoFiltri != null ? Array.from(ElencoFiltri) : null), ordine: (ElencoOrdine != null ? Array.from(ElencoOrdine) : null) }),
                traditional: true,
                type: "POST",
                cache: false,
                async: true
            }

            let jqXhr: JQueryXHR = $.ajax(ajaxSettings);


            jqXhr.done(function (partialViewResult) {
                $(Utility.BodyName).fadeOut(200, "swing", function () {
                    $(Utility.BodyName).html(partialViewResult);
                });
                $(Utility.BodyName).fadeIn(200);
            });
        }

        function OnPagerChange(e: any) {
            e.preventDefault();
            let _tmpURL: string = $(e.currentTarget).data("tabella-pager-url");
            if (_tmpURL != null && _tmpURL != undefined)
                CallAjaxFiltriOrdine(_tmpURL);
            else
                console.error("Change page error");
        }

        //----------------------------------------------------------------------------------------------

        function ChangeToolbarStatus() {
            //disable all
            $("[data-tabella-modifica]").addClass("disabled");
            $("[data-tabella-elimina]").addClass("disabled");
            $("[data-tabella-duplica]").addClass("disabled");
            $("[data-tabella-compara]").addClass("disabled");

            if (ListaRigheSelezionate.size > 0) {
                $("[data-tabella-elimina]").removeClass("disabled");
            }
            if (ListaRigheSelezionate.size == 1) {
                $("[data-tabella-modifica]").removeClass("disabled");
                $("[data-tabella-duplica]").removeClass("disabled");
            }
            if (ListaRigheSelezionate.size == 2) {
                $("[data-tabella-compara]").removeClass("disabled");
            }
        }

        function OnRigaClick(e: any) {
            let _this = $(e.currentTarget);

            _this.toggleClass("table-active");

            let _check = _this.find("td > div > [data-riga-id]");

            _check.prop("checked", !_check.prop("checked"));
            if (_check.prop("checked")) {
                ListaRigheSelezionate.add(_check.data("riga-id"));

            }
            else {
                ListaRigheSelezionate.delete(_check.data("riga-id"));
            }

            ChangeToolbarStatus();
        }

        function OnNuovoClick(e: any) {
            e.preventDefault();
            $(e.currentTarget).tooltip("hide");

            if ($("#utilityTabella").data("useformaside")) {
                let _opzioniCharm: Controlli.FormAside.CharmOptions = new Controlli.FormAside.CharmOptions;

                _opzioniCharm.Url = $(e.currentTarget).data("tabella-nuovo-url");
                _opzioniCharm.UrlData = null;
                _opzioniCharm.Titolo = $(e.currentTarget).data("tabella-nuovo-titolo");
                if ($(e.currentTarget).data("tabella-nuovo-dimensione") != undefined)
                    _opzioniCharm.Dimensione = $(e.currentTarget).data("tabella-nuovo-dimensione");

                Controlli.FormAside.Load(_opzioniCharm);
            } else {
                Controlli.Ajax.AjaxLoadingHTML($(e.currentTarget).data("tabella-nuovo-url"));
            }
        }
        function OnModificaClick(e: any) {
            e.preventDefault();
            $(e.currentTarget).tooltip("hide");

            if (ListaRigheSelezionate.size == 1) {
                if ($("#utilityTabella").data("useformaside")) {
                    let _opzioniCharm: Controlli.FormAside.CharmOptions = new Controlli.FormAside.CharmOptions;

                    _opzioniCharm.Url = $(e.currentTarget).data("tabella-modifica-url");
                    _opzioniCharm.UrlData = { Id: ListaRigheSelezionate.values().next().value };
                    _opzioniCharm.Titolo = $(e.currentTarget).data("tabella-modifica-titolo");
                    if ($(e.currentTarget).data("tabella-modifica-dimensione") != undefined)
                        _opzioniCharm.Dimensione = $(e.currentTarget).data("tabella-modifica-dimensione");

                    Controlli.FormAside.Load(_opzioniCharm);
                } else {
                    Controlli.Ajax.AjaxLoadingHTML($(e.currentTarget).data("tabella-modifica-url"), null, { Id: ListaRigheSelezionate.values().next().value });
                }

            } else { alert("selezionare una riga"); }
        }
        function OnEliminaClick(e: any) {
            e.preventDefault();
            $(e.currentTarget).tooltip("hide");

            let _confirmOptions: Confirm.ConfirmOptions = new Confirm.ConfirmOptions;

            _confirmOptions.Messaggio = $(e.currentTarget).data("tabella-elimina-message");
            _confirmOptions.Url = $(e.currentTarget).data("tabella-elimina-url");
            _confirmOptions.UrlData = { Ids: Array.from(ListaRigheSelezionate) };

            Confirm.Load(_confirmOptions);
        }
        function OnDuplicaClick(e: any) {
            e.preventDefault();
            $(e.currentTarget).tooltip("hide");

            if (ListaRigheSelezionate.size == 1) {
                if ($("#utilityTabella").data("useformaside")) {
                    let _opzioniCharm: Controlli.FormAside.CharmOptions = new Controlli.FormAside.CharmOptions;

                    _opzioniCharm.Url = $(e.currentTarget).data("tabella-duplica-url");
                    _opzioniCharm.UrlData = { Id: ListaRigheSelezionate.values().next().value };
                    _opzioniCharm.Titolo = $(e.currentTarget).data("tabella-duplica-titolo");
                    if ($(e.currentTarget).data("tabella-duplica-dimensione") != undefined)
                        _opzioniCharm.Dimensione = $(e.currentTarget).data("tabella-duplica-dimensione");

                    Controlli.FormAside.Load(_opzioniCharm);
                } else {
                    Controlli.Ajax.AjaxLoadingHTML($(e.currentTarget).data("tabella-duplica-url"), null, { Id: ListaRigheSelezionate.values().next().value });
                }
            } else { alert("selezionare una riga"); }
        }
        function OnCompareClick(e: any) {
            e.preventDefault();
            $(e.currentTarget).tooltip("hide");

            if (ListaRigheSelezionate.size == 2) {
                let _tmp = ListaRigheSelezionate.values();

                let _opzioniCharm: Controlli.FormAside.CharmOptions = new Controlli.FormAside.CharmOptions;

                _opzioniCharm.Url = $(e.currentTarget).data("tabella-compara-url");
                _opzioniCharm.UrlData = { Id: _tmp.next().value };
                _opzioniCharm.Titolo = $(e.currentTarget).data("tabella-compara-titolo");
                if ($(e.currentTarget).data("tabella-compara-dimensione") != undefined)
                    _opzioniCharm.Dimensione = $(e.currentTarget).data("tabella-compara-dimensione");

                Controlli.FormAside.Load(_opzioniCharm);

                let _opzioniCharm2: Controlli.FormAside.CharmOptions = new Controlli.FormAside.CharmOptions;

                _opzioniCharm2.Url = $(e.currentTarget).data("tabella-compara-url");
                _opzioniCharm2.UrlData = { Id: _tmp.next().value };
                _opzioniCharm2.Titolo = $(e.currentTarget).data("tabella-compara-titolo");
                if ($(e.currentTarget).data("tabella-compara-dimensione") != undefined)
                    _opzioniCharm2.Dimensione = $(e.currentTarget).data("tabella-compara-dimensione");
                IsOpen = true;
                Controlli.FormAside.LoadSecondary(_opzioniCharm2);
            } else { alert("selezionare due righe"); }
        }

        function OnExportPDF(e: any) {
            e.preventDefault();

            //(<any>$('#tbl_export')).tableExport({
            //    type: 'pdf',
            //    ignoreColumn: [0],
            //    jspdf: {
            //        orientation: 'landscape'
            //    }
            //});

            (<any>$('#tbl_export')).tableExport({
                type: 'pdf',
                ignoreColumn: [0],
                jspdf: {
                    orientation: 'landscape'
                }
            });

        }
        function OnExportEXCEL(e: any) {
            e.preventDefault();

            (<any>$('#tbl_export')).tableExport({
                type: 'excel',
                fileName: 'ExportLista',
                ignoreColumn: [0],
                mso: {
                    fileFormat: 'xlss',
                    pageOrientation: 'landscape'
                }
            });
        }
        function OnExportWORD(e: any) {
            e.preventDefault();

            (<any>$('#tbl_export')).tableExport({
                type: 'doc',
                fileName: 'ExportLista',
                ignoreColumn: [0],
                numbers: {
                    html: {
                        decimalMark: ',',
                        thousandsSeparator: '.'
                    },
                    output: {
                        decimalMark: ',',
                        thousandsSeparator: '.'
                    }
                }
            });
        }
        function OnExportCSV(e: any) {
            e.preventDefault();

            (<any>$('#tbl_export')).tableExport({
                type: 'csv',
                fileName: 'ExportLista',
                ignoreColumn: [0],
                csvEnclosure: '',
                csvSeparator: ';',
                numbers: {
                    html: {
                        decimalMark: ',',
                        thousandsSeparator: '.'
                    },
                    output: {
                        decimalMark: ',',
                        thousandsSeparator: '.'
                    }
                }
            });
        }
        function OnExportIMAGE(e: any) {
            e.preventDefault();

            (<any>$('#tbl_export')).tableExport({
                type: 'png',
                fileName: 'ExportLista',
                ignoreColumn: [0],
                numbers: {
                    html: {
                        decimalMark: ',',
                        thousandsSeparator: '.'
                    },
                    output: {
                        decimalMark: ',',
                        thousandsSeparator: '.'
                    }
                }
            });
        }
        function OnExportJSON(e: any) {
            e.preventDefault();

            (<any>$('#tbl_export')).tableExport({
                type: 'json',
                fileName: 'ExportLista',
                ignoreColumn: [0],
                numbers: {
                    html: {
                        decimalMark: ',',
                        thousandsSeparator: '.'
                    },
                    output: {
                        decimalMark: ',',
                        thousandsSeparator: '.'
                    }
                }
            });
        }
        function OnExportXML(e: any) {
            e.preventDefault();

            (<any>$('#tbl_export')).tableExport({
                type: 'xml',
                fileName: 'ExportLista',
                ignoreColumn: [0],
                numbers: {
                    html: {
                        decimalMark: ',',
                        thousandsSeparator: '.'
                    },
                    output: {
                        decimalMark: ',',
                        thousandsSeparator: '.'
                    }
                }
            });
        }
    }

    interface ColonnaTabella {
        Nome: string;
        IsVisibile: boolean;
    }

    interface FiltroTabella {
        NomeFiltro: string;
        NomeEntity: string;
        Valore: any;
    }

    interface OrdineTabella {
        Nome: string;
        Ordine: number;
        Tipo: SortOrder;
    }

    enum SortOrder {
        None,
        Ascending,
        Descending
    }

}
